import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtEuro } from "@/lib/status";
import { Card } from "@/components/ui/card";

export default function Reports() {
  const [data, setData] = useState({ stores: [] });
  useEffect(() => { api.get("/reports").then((r) => setData(r.data)); }, []);

  return (
    <div className="space-y-6">
      <h1 className="font-heading text-2xl font-extrabold tracking-tight sm:text-3xl">Report</h1>
      <div className="grid gap-6 md:grid-cols-2">
        {data.stores.map((s) => (
          <Card key={s.store_id} className="p-6" data-testid={`report-${s.store_id}`}>
            <h2 className="font-heading text-lg font-bold">{s.store_name}</h2>
            <div className="mt-4 grid grid-cols-2 gap-4">
              <Metric label="Riparazioni" value={s.repairs} />
              <Metric label="Completate" value={s.completed} />
              <Metric label="Annullate" value={s.cancelled} />
              <Metric label="Preventivi" value={s.quotes} />
              <Metric label="Accettazione" value={`${s.acceptance_rate}%`} />
              <Metric label="Fatturato" value={fmtEuro(s.revenue)} />
            </div>
          </Card>
        ))}
        {data.stores.length === 0 && <Card className="p-12 text-center text-muted-foreground">Nessun dato disponibile.</Card>}
      </div>
    </div>
  );
}

function Metric({ label, value }) {
  return (
    <div className="rounded-lg bg-secondary/50 p-3">
      <div className="font-heading text-xl font-extrabold">{value}</div>
      <div className="text-xs text-muted-foreground">{label}</div>
    </div>
  );
}
